import { UseMutateFunction } from 'react-query';
import { AxiosError, AxiosResponse } from 'axios';
import { UpdateSubjectRegistrationDraftRequest } from '../api/candidate/exam/model';
import { GenericErrorResponse } from '../api';
import { IEditStateHandler } from '../components/EditExamSubjectsModal';

const mutateEditPaperSubject = (
  callback: UseMutateFunction<
    AxiosResponse<UpdateSubjectRegistrationDraftRequest>,
    AxiosError<AxiosError<GenericErrorResponse>>,
    UpdateSubjectRegistrationDraftRequest
  >,
  mutatePayload: UpdateSubjectRegistrationDraftRequest
) => {
  callback(mutatePayload);
};

const onEditModalOpenHandler = (
  examRegistrationDetailUuid: string,
  editModalHandler: IEditStateHandler,
  subjectCode?: string
): string => {
  const { openEditModal, setOpenEditModal } = editModalHandler;

  if (!subjectCode) {
    setOpenEditModal(() => ({
      ...openEditModal,
      [examRegistrationDetailUuid]: true,
    }));
  } else {
    setOpenEditModal(() => ({
      ...openEditModal,
      [subjectCode]: true,
      [examRegistrationDetailUuid]: false,
    }));
  }

  return examRegistrationDetailUuid;
};
export { mutateEditPaperSubject, onEditModalOpenHandler };
